export const MODEL_TYPE = 'MODEL'
export const MAKER_TYPE = 'MAKER'
export const BRAND_TYPE = 'BRAND'
export const BROKER_TYPE = 'BROKER'



// WEBPACK FOOTER //
// ./src/components/AddItemModal/constants.js